import { Cell, Pie, PieChart } from 'recharts'
import React from 'react'
import { Box, colors, Typography } from '@mui/material'
import { getIdentityName } from '../../../utils/identity'
import { grey } from '@mui/material/colors'

const PieCharts = ({ activities, identities, activityTypes }) => {
  if (!activities?.allActivitiesByIdentityIds.length)
    return <Typography>No data</Typography>

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        mt: 2,
        flexDirection: 'center',
        justifyContent: 'center',
      }}
    >
      {activities.allActivitiesByIdentityIds.map((identity, i) => {
        const data = identity.activities
          .filter((a) => a.activityTypeId !== 6)
          .map((a) => {
            const type = activityTypes.find((at) => at.id === a.activityTypeId)

            return { ...a, name: type.name }
          })

        const resolvedIdentity = identities.find(
          (ii) => ii.id === identity.identityId
        )

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              borderRadius: '3px',
              boxShadow: '0 7px 9px -7px rgb(0 0 0 / 40%)',
              p: 1,
              m: 1,
              backgroundColor: 'white',
            }}
          >
            <Typography>
              <b>{getIdentityName(resolvedIdentity)}</b>
            </Typography>
            {!data.length && <Typography>No data</Typography>}
            {data.length && (
              <PieChart key={i} width={450} height={250}>
                <Pie
                  data={data}
                  dataKey={'count'}
                  cx={'50%'}
                  cy={'50%'}
                  outerRadius={50}
                  fill='#8884d8'
                  label={(val) => {
                    const type = activityTypes.find(
                      (at) => at.id === val.payload.activityTypeId
                    )

                    return `${type.name}: ${val.payload.count}`
                  }}
                >
                  {data.map((entry, index) => {
                    const type = activityTypes.find(
                      (at) => at.id === entry.activityTypeId
                    )

                    return (
                      <Cell
                        key={`cell-${index}`}
                        fill={colors[type.color][800]}
                      />
                    )
                  })}
                </Pie>
              </PieChart>
            )}
          </Box>
        )
      })}
    </Box>
  )
}

export default PieCharts
